<template>
  <div id="app">
    <el-container class="flextext">
      <home-head></home-head>
      <el-main>
        <el-row class="main_dingbu">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="hidden-sm-and-down">
            <div class="main_fenlan">
              <el-row :gutter="10">
                <el-col :xs="24" :sm="7" :md="7" :lg="5" :xl="5">
                  <div class="main_fenlan_neirong visible-hidden" v-if="is_open.lanmu==1">
                    <a class="lanmu " href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/fenxi.png"/>
                        <span class="main_fenlan_neirong_list_text">分析仪器</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/ershou.png"/>
                        <span class="main_fenlan_neirong_list_text">二手仪器设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/shiyan.png"/>
                        <span class="main_fenlan_neirong_list_text">实验室通用设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/guangxue.png"/>
                        <span class="main_fenlan_neirong_list_text">光学设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/tongyong.png"/>
                        <span class="main_fenlan_neirong_list_text">通用设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/hangye.png"/>
                        <span class="main_fenlan_neirong_list_text">行业专用仪器</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/cailiao.png"/>
                        <span class="main_fenlan_neirong_list_text">工业材料</span>
                      </div>
                    </a>
                  </div>
                  <div class="main_fenlan_neirong visible-hidden" v-if="is_open.lanmu==2">
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/fenxi.png"/>
                        <span class="main_fenlan_neirong_list_text">第二</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/ershou.png"/>
                        <span class="main_fenlan_neirong_list_text">二手仪器设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/shiyan.png"/>
                        <span class="main_fenlan_neirong_list_text">实验室通用设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/guangxue.png"/>
                        <span class="main_fenlan_neirong_list_text">光学设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/tongyong.png"/>
                        <span class="main_fenlan_neirong_list_text">通用设备</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/hangye.png"/>
                        <span class="main_fenlan_neirong_list_text">行业专用仪器</span>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_fenlan_neirong_list">
                        <img class="main_fenlan_neirong_list_img" src="../../../assets/home/cailiao.png"/>
                        <span class="main_fenlan_neirong_list_text">工业材料</span>
                      </div>
                    </a>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="17" :md="15" :lg="14" :xl="14">
                  <div class="top_lunbo">
                    <el-carousel height="415px">
                      <el-carousel-item v-for="(v,index) in banner" v-bind:key="index">
                        <!--                    <h3 class="small">{{ item }}</h3>-->
                        <img style="width: 100%" :src="v.img"/>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </el-col>
                <el-col class="hidden-md-and-down" :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                  <div class=" main_fenglu">
                    <div class="main_fenglu_fenge"></div>
                    <div class="main_fenglu_huanyi">Hi~您好</div>
                    <div class="main_fenglu_huanyi2">欢迎光临</div>
                    <a class="xuanzhong wenzi" href="user.html#index">
                      <button class="main_fenglu_button">{{ $store.state.information != '' ? '个人中心' : '请登录' }}</button>
                    </a>
                    <a class="xuanzhong wenzi" href="user.html#/" v-if="$store.state.information==''">
                      <button class="main_fenglu_button2">免费注册</button>
                    </a>
                    <div class="main_fenglu_fubiao">
                      <el-divider content-position="center">快接入口</el-divider>
                    </div>
                    <a class="xuanzhong wenzi" href="user.html#/trans/sell/pending" @click="UserDisposh('pending')">
                      <div class="main_fenglu_rukou">
                        <div class="main_fenglu_rukou_beijing">
                          <img class="main_fenglu_rukou_beijing_img" src="../../../assets/home/chuli.png"/>
                        </div>
                        <div class="main_fenglu_rukou_text">待处理</div>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="user.html#/trans/sell/to-pay" @click="UserDisposh('2')">
                      <div class="main_fenglu_rukou">
                        <div class="main_fenglu_rukou_beijing">
                          <img class="main_fenglu_rukou_beijing_img" src="../../../assets/home/fukuan.png"/>
                        </div>
                        <div class="main_fenglu_rukou_text">待支付</div>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="user.html#/trans/sell/delivering">
                      <div class="main_fenglu_rukou">
                        <div class="main_fenglu_rukou_beijing">
                          <img class="main_fenglu_rukou_beijing_img" src="../../../assets/home/daifahuo.png"/>
                        </div>
                        <div class="main_fenglu_rukou_text">待发货</div>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="user.html#/trans/sell/shipping">
                      <div class="main_fenglu_rukou">
                        <div class="main_fenglu_rukou_beijing">
                          <img class="main_fenglu_rukou_beijing_img" src="../../../assets/home/shouhuo.png"/>
                        </div>
                        <div class="main_fenglu_rukou_text">待收货</div>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="user.html#/trans/sell/refunding">
                      <div class="main_fenglu_rukou">
                        <div class="main_fenglu_rukou_beijing">
                          <img class="main_fenglu_rukou_beijing_img" src="../../../assets/home/tuihuo.png"/>
                        </div>
                        <div class="main_fenglu_rukou_text">退货中</div>
                      </div>
                    </a>
                    <a class="xuanzhong wenzi" href="user.html#/trans/sell/complaining">
                      <div class="main_fenglu_rukou">
                        <div class="main_fenglu_rukou_beijing">
                          <img class="main_fenglu_rukou_beijing_img" src="../../../assets/home/weiquan.png"/>
                        </div>
                        <div class="main_fenglu_rukou_text">维权中</div>
                      </div>
                    </a>
                    <div class="main_fenglu_fubiao2">
                      <el-divider content-position="center">仪小星讲堂</el-divider>
                    </div>
                    <a class="xuanzhong wenzi" href="/home.html#/college/category/7">
                      <div class="main_fenglu_pingtai">平台规则</div>
                    </a>
                    <a class="xuanzhong wenzi" href="/home.html#/college/novice">
                      <div class="main_fenglu_pingtai">平台公告</div>
                    </a>
                    <a class="xuanzhong wenzi" href="/home.html#/college/novice">
                      <div class="main_fenglu_pingtai">网站学习</div>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="hidden-sm-and-up">
            <div>
              <el-carousel height="250px">
                <el-carousel-item v-for="item in 4" :key="item">
                  <!--                    <h3 class="small">{{ item }}</h3>-->
                  <img style="width: 100%" src="../../../assets/home/banner.png"/>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="main_phone_shaixuan">
              <i class="el-icon-menu" width="40px"
                 @click="is_open.phone_shaixuan===1?is_open.phone_shaixuan=0:is_open.phone_shaixuan=1"
                 style="color: #FFFFFF;font-size: 40px;margin-top: 8px;margin-left: 10px"></i>
              <i class="el-icon-search"
                 @click="is_open.phone_sousuokuang===1?is_open.phone_sousuokuang=0:is_open.phone_sousuokuang=1"
                 style="color: #FFFFFF;font-size: 35px;
              float: right;margin-top: 10px;margin-right: 10px;"></i>
            </div>
            <div class="main_phone_shaixuan_neirong" v-if="is_open.phone_shaixuan==1">
              <div class="main_phone_shaixuan_neirong_text">分析仪器</div>
              <div class="main_phone_shaixuan_neirong_text">二手仪器</div>
              <div class="main_phone_shaixuan_neirong_text">实验室通用设备</div>
              <div class="main_phone_shaixuan_neirong_text">光学设备</div>
              <div class="main_phone_shaixuan_neirong_text">通用设备</div>
              <div class="main_phone_shaixuan_neirong_text">行业专用仪器</div>
              <div class="main_phone_shaixuan_neirong_text">工业材料</div>
            </div>
            <div class="main_phone_sousuo_neirong" v-if="is_open.phone_sousuokuang==1">
              <div class="main_phone_sousuo_kuang"></div>
              <el-button type="primary" size="medium" icon="el-icon-search"
                         style="background:none; outline:none; border:none;
                         height: 57px;    border-radius:0;
                         float: left;background: #2f549f; margin-top: 10px">搜索
              </el-button>

            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_pinpai_jiange"></div>
          </el-col>
          <!--品牌商家-->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_pinpai">
              <span class="main_pinpai_jiange_biaoti">品牌商家</span>
              <el-row>
                <!--              <div class="main_pinpai_logo_fenge"></div>-->
                <el-col class="pinpai-col" :xs="12" :sm="6" :md="6" :lg="4" :xl="4" v-for="(item,index) in list" :key="index">
                  <div class="main_pinpai_logo_neirong">

                    <!--                    <img class="main_pinpai_logo_neirong_img" style="width: 100%;height: 200px" :src="url+'/storage/'+item.avatar"/>-->
                    <a :href="item.link" class="" >
                      <el-image class="main_pinpai_logo_neirong_img"
                                style="width: 100%;height: 200px;padding:5px"
                                :src="item.img" fit="fill"
                      >
                        <div slot="error" class="image-slot">
                          <img class="main_pinpai_logo_neirong_img"
                               style="width: 100%;height: 200px"
                               src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="">
                        </div>
                      </el-image>
                    </a>

                  </div>
                  <div style="text-align: center;color: #333333;">{{item.name}}</div>
                </el-col>
              </el-row>

            </div>
          </el-col>
          <!-- 品牌商家结束-->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_tesefuwuzhida_jiange"></div>
          </el-col>
          <!--最新商品-->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_shangpin">
              <div class="main_shangpin_lanmu">
                <!--                <div class="main_shangpin_hentiao_left"></div>-->
                <!--                <div class="main_shangpin_hentiao_left2"></div>-->
                <!--                <div class="main_shangpin_lanmu_text">最新商品</div>-->
                <!--                <div class="main_shangpin_lanmu_text2">/查看更多/</div>-->
                <!--                <div class="main_shangpin_hentiao_right"></div>-->
                <!--                <div class="main_shangpin_hentiao_right2"></div>-->
                <img class="main_shangpin_lanmu_img" src="../../../assets/home/9b94772e0215add9edbddf4b0142490.png">
              </div>
              <el-row :gutter="10">
                <!--  {{list2}}-->
                <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="4" v-for="(item,index) in list2" :key="index">
                  <a v-if="item.api_edition == 2202" :href="'#/dianpu_new/'+item.id">
                    <div class="main_shangpin_neirong">
                      <!--  <img :src="url+'/storage/'+item.cover" class="main_shangpin_neirong_img"/>-->
                      <el-image
                              class="main_shangpin_neirong_img"
                              :src="url+'/storage/'+item.cover"
                              fit="cover">
                      </el-image>
                      <div class="main_shangpin_neirong_biaoqian">最新商品</div>
                      <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                        >
                          <div class="main_shangpin_neirong_biaoti"
                               :title=item.title>
                            {{ item.title }}
                          </div>
                        </el-col>
                      </el-row>
                      <!--   <div class="main_shangpin_neirong_haopin">浏览量{{ item.view_num }}</div>-->
                      <!--  <div class="main_shangpin_neirong_haopin">162人购买</div>-->
                      <!--     <div class="main_shangpin_neirong_jiage">￥{{ item.cash=='0.00'?item.price_yugu:item.cash}}</div>-->
                      <!--价格显示-->
                      <div class="main_shangpin_neirong_jiage">
                         <span class="prices" v-if="item.cash==0.00">价格
                         <span class="moneys">¥</span><span class="value">面议</span>
                         </span>
                        <span class="prices" v-else>价格
                         <span class="moneys">¥</span><span class="value">{{ item.cash }}</span>
                         </span>
                      </div>
                      <div class="shangjia_name" :title="item.shop_name">
                        {{ item.shop_name }}
                      </div>
                    </div>
                  </a>
                  <a v-else :href="'#/dianpu_index/'+item.id">
                    <div class="main_shangpin_neirong">
                      <!--  <img :src="url+'/storage/'+item.cover" class="main_shangpin_neirong_img"/>-->
                      <el-image
                              class="main_shangpin_neirong_img"
                              :src="url+'/storage/'+item.cover"
                              fit="fill">
                      </el-image>
                      <div class="main_shangpin_neirong_biaoqian">最新商品</div>
                      <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                        >
                          <div class="main_shangpin_neirong_biaoti"
                               :title=item.title>
                            {{ item.title }}
                          </div>
                        </el-col>
                      </el-row>
                      <!--   <div class="main_shangpin_neirong_haopin">浏览量{{ item.view_num }}</div>-->
                      <!--  <div class="main_shangpin_neirong_haopin">162人购买</div>-->
                      <!--     <div class="main_shangpin_neirong_jiage">￥{{ item.cash=='0.00'?item.price_yugu:item.cash}}</div>-->
                      <!--价格显示-->
                      <div class="main_shangpin_neirong_jiage">
                         <span class="prices" v-if="item.price_yugu==0.00">明码标价
                         <span class="moneys">¥</span><span class="value">{{ item.cash }}</span>
                         </span>
                        <span class="prices" v-else>预估价格
                         <span class="moneys">¥</span><span class="value">{{ item.price_yugu }}</span>
                         </span>
                      </div>
                      <div class="shangjia_name" :title="item.shop_name">
                        {{ item.shop_name }}
                      </div>
                    </div>
                  </a>
                </el-col>

              </el-row>
            </div>

          </el-col>

          <!--最新商品结束-->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_tesefuwuzhida_jiange"></div>
          </el-col>
          <!--          {{list3}}-->
          <!--服务直达-->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_fuwuzhida">
              <el-row :gutter="10">
                <el-col :xs="10" :sm="10" :md="13" :lg="10" :xl="10">
                  <div class="main_fuwuzhida_fenmian">
                    <!--    <img class="main_fuwuzhida_fenmian_img" src="../../../assets/home/fuwuzhida.png" />-->
                    <div class="main_fuwuzhida_fenmian_text">服务直达</div>
                    <div class="main_fuwuzhida_fenmian_text2">查看更多
                      <img src="../../../assets/home/c14fa4ea66518e6d5e1ab771632a73c.png">
                    </div>
                  </div>
                </el-col>
                <el-col :xs="14" :sm="14" :md="11" :lg="14" :xl="14" class="hidden-xs-only">
                  <el-row :gutter="10">
                    <block v-for="(fuwu,index) in list3" :key="index">
                      <a v-if="index<4" :href="'#/dianpu_details/'+fuwu.id">
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                          <div class="main_fuwuzhida_neirong">
                            <el-image :src="url+'/storage/'+fuwu.cover"
                                      style="width: 50%;height: 100%;float: left;"
                                      fit="cover">
                            </el-image>

                          </div>
                          <div class="fwzdtext" :title="fuwu.title">
                            {{fuwu.title}}
                          </div>
                          <div class="jiage" :title="fuwu.price_yugu">¥{{ fuwu.price_yugu }}
                          </div>
                          <div class="shangjia_name_b" :title="fuwu.shop_name">
                            {{ fuwu.shop_name }}
                          </div>
                        </el-col>
                      </a>

                    </block>
                  </el-row>
                </el-col>
              </el-row>

              <el-row :gutter="10" style="margin-top: 10px">
                <block v-for="(fuwu,index) in list3" :key="index"
                >
                  <a v-if="index>=4&&index<10" :href="'#/dianpu_details/'+fuwu.id">
                    <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
                      <div class="main_fuwuzhida_neirong">
                        <el-image :src="url+'/storage/'+fuwu.cover"
                                  style="width: 50%;height: 100%;float: left;"
                                  fit="cover"></el-image>
                        <div class="fwzdtext_a" :title="fuwu.title">{{fuwu.title}}</div>

                      </div>
                      <div class="jiage_a" :title="fuwu.price_yugu">
                        ¥{{ fuwu.price_yugu }}
                      </div>
                      <div class="shangjia_name_a" :title="fuwu.shop_name">
                        {{ fuwu.shop_name }}
                      </div>
                    </el-col>
                  </a>
                </block>

              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_tesefuwuzhida_jiange"></div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_tesejiance">
              <el-row :gutter="10">
                <el-col class="hidden-xs-only" :sm="6" :md="6" :lg="5" :xl="5">
                  <img src="../../../assets/home/jiance_fengmian.png" class="main_jiance_fenmian"/>
                  <div class="main_jiance_fenmian_juxing">
                    <div class="main_jiance_fenmian_juxing_text">特色检测</div>
                    <a class="xuanzhong wenzi" href="">
                      <div class="main_jiance_fenmian_juxing_text2">查看更多
                        <img src="../../../assets/home/c14fa4ea66518e6d5e1ab771632a73c.png">
                      </div>
                    </a>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="18" :md="18" :lg="19" :xl="19">
                  <div>
                    <!-- 先删掉，两行得时候会被遮挡 <div style="width: 70%;height: 1px;position: absolute; margin-left: 5%;margin-top: 199px;background: #E1E1E1;"></div> -->
                    <el-row :gutter="10" class="main_jiance_sj">
                      <el-col :lg="6" :sm="8" :xs="12" v-for="(item,index) in list4" :key="index">
                        <div class="main_jiance_sj_neirong" style="width: 100%">
                          <a :href="'#/dianpu_details/' + item.fuwu_id">
                            <el-image :src="url+'/storage/'+item.cover"
                                      class="main_jiance_sj_neirong_img"
                                      style="height: 175px;width: 100%"
                                      fit="cover"></el-image>
                            <div class="neirong-title" style="text-align: center;color: #333333">{{item.title}}</div>
                          </a>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_jinpaijiance_jiange"></div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="  main_width">
              <div class="main_jinpai_top">
                <img class="main_jinpai_top_img" src="../../../assets/home/jinpaijuxing.png"/>
                <img class="main_jinpai_top_img2" src="../../../assets/home/jinapi.png">
                <div class="main_jinpai_top_text">金牌工程师</div>
                <a class="xuanzhong wenzi" href="">
                  <div class="main_jinpai_top_text2">查看更多
                    <img src="../../../assets/home/c14fa4ea66518e6d5e1ab771632a73c.png">
                  </div>
                </a>
              </div>
              <el-row class="main_jinpai" :gutter="10">
                <el-col :lg="8" :sm="12" :xs="24" v-for="item in list5" :key="item.uid">
                  <div class="main_gcs_liebiao">
                    <a :href="'#/shops/index/' + item.shop.id">
                      <div class="main_gcs_liebiao_top">
                        <img class="main_gcs_liebiao_top_img" src="../../../assets/home/laoshi.png"/>
                      </div>
                      <div style="text-align:center">
                        <span class="main_jinpai_text jinpai_name">{{item.name }}</span>
                        <span class="main_jinpai_text2 jinpai_zhicheng">高级工程师</span>
                      </div>
                      <div class="main_jinpai_text2 jinpai_jingli">
                          技能标签:
                          <span v-for="(item_tag,index) in item.tag" :key="index">
                            {{item_tag.tag_value}}{{ message }}
                          </span>
                      </div>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="main_jinpai_bottom"></div>
          </el-col>
        </el-row>
      </el-main>
      <footerall></footerall>
    </el-container>
  </div>
</template>
<script>
    import home_head from '../../common/home-head';
    import footerall from '../../common/footer';

    export default {
        name: 'App',
        components: {
            'home-head': home_head,
            footerall
        },
        data: function () {
            return {
                banner: [],
                aaa: true,
                list: '',
                list2: '',
                list3: '',
                list4: '',
                list5: '',
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                    phone_shaixuan: 0,
                    phone_sousuokuang: 0,
                },
                url: '',
                information: '',
                message:';',
            }
        },
        methods: {
            list_info() {
                var t = this
                var url = window.config.api_url + '/college/shop/info?id=' + this.$route.params.id
                t.axios.get(url).then(res => {
                    t.item = res.data
                    console.log("123456", res.data)
                })
            },
            UserDisposh(information) {
                window.sessionStorage.setItem('information', information)
            },
            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                console.log(this.is_open.sousuo)
            },
            init() {
                this.url = window.config.api_url
                this.information = this.$store.state.information
                console.log(this.$store.state.information, 8848)
                this.pinpai()
                this.shangpin()
                this.fuwu()
                this.jiance()
                this.gongcheng()
                this.lunbo();
            },
            gongcheng() {
                var t = this
                var url = window.config.api_url + '/college/home/recommend/engineer?limit=12'
                t.axios.get(url).then(res => {
                    // console.log(res)
                    // http://api.yihai.com/college/home/user/list
                    t.list5 = res.data
                })
            },
            lunbo() {
                var that = this
                this.axios.get(window.config.api_url + '/college/banner?position=home')
                    .then(res => {
                        that.banner = res.data
                        console.log(that.banner)
                    });
            },
            jiance() {
                var t = this
                var url = window.config.api_url + '/college/home/testing/list?limit=8'
                t.axios.get(url).then(res => {
                    console.log(res,8888888887)
                    t.list4 = res.data
                })
            },
            fuwu() {
                var t = this
                var url = window.config.api_url + '/college/fuwu/list/newest?limit=12'
                t.axios.get(url).then(res => {
                    // console.log(res)
                    t.list3 = res.data
                    console.log("weeweqwew ", res.data)
                })
            },
            pinpai() {
                var t = this
                var url = window.config.api_url + '/college/goods/list/newest?limit=24'
                // if (t.aaa==true){
                //   url += '&cate_id=168'
                // }

                t.axios.get(url).then(res => {
                    let list = []
                    console.log("我是res.data里面的数据", res.data)
                    res.data.forEach((item) => {
                        var ishave = list.some((item1) => {             //判断list里面有没有公司名字相同的数据
                            return item1.shop_name == item.shop_name;  //返回true 和 false
                        });
                        if (ishave) {   //如果有的话  判断数量是否大于5
                            var number = 0;
                            list.forEach((item2) => {
                                if (item2.shop_name == item.shop_name) {
                                    number += 1;
                                }
                            })
                            if (number < 5) {   //数量小于5则添加
                                if (list.length < 48) {  //如果list的长度小于24则添加
                                    list.push(item)
                                }
                            }
                        } else {  //list里面没有相同得数据
                            if (list.length < 48) {
                                list.push(item) //直接添加
                            }
                        }
                    })
                    t.list2 = list;
                    console.log(t.list2)
                })
            },
            shangpin() {
                var t = this;
                var url = window.config.api_url + '/college/banner?position=home_shouye';
                t.axios.get(url).then((res) => {
                    t.list = res.data
                    console.log(t.list, 11111)
                })
            }

        },
        created() {
            this.init()
        }
    }
</script>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
  //@head_text : Source Han Sans CN;
  @font-face {
    font-family: 'Source-Han-Ligh27fa9ce3662351d';
  }

  @import "../../../assets/css/home";
  a {
    text-decoration: none !important;
  }

  a:-webkit-any-link {
    color: -webkit-link;
    cursor: pointer;
  }

  .shangjia_name {
    color: #A8A297;
    margin-top: 10px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: normal;
  }

  .jiage {
    position: relative;
    top: -75px;
    left: 190px;
    color: #F03726;
    height: 10px;

  }

  .shangjia_name_a {
    position: relative;
    top: -45px;
    left: 105px;
    width: 40%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: normal;
    color: #A8A297;
  }

  .shangjia_name_b {
    position: relative;
    top: -40px;
    left: 190px;
    width: 40%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: normal;
    color: #A8A297;
  }

  -
  .yugujiage {
    margin-left: 5px;
  }

  .jiage_a {
    position: relative;
    /*top: 30px;*/
    top: -80px;
    left: 105px;
    color: #F03726;
    height: 10px;

    /*left: 190px;*/
  }

  .fwzdtext {
    width: 30%;
    height: 100%;
    position: relative;
    left: -50px;
    top: -120px;
    font-size: 15px;
    /*margin-top: 15px;*/
    float: right;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: normal;
  }

  .fwzdtext_a {
    width: 35%;
    height: 100%;
    position: relative;
    left: -20px;
    top: 10px;
    /*margin-left: 10px;*/
    /*margin-right: 5px;*/
    font-size: 15px;
    /*margin-top: -95px;*/
    float: right;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: normal;
  }

  .flextext {
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;
  }

  .el-footer {
    background-color: #FFFFFF;
    color: #333;
    //text-align: center;
    padding: 0 0;
    //line-height: 60px;
  }

  .el-main {
    background-color: #F9F9F9;
    color: #333;
    //text-align: center;
    padding: 0 0;
    //line-height: 500px;
  }

  .el-header {
    background: #FFFFFF;
    padding: 0 0;

  }

  .header_pc {
    border-bottom: #4E6EF2 solid 3px;
  }


  #app {
    .main_dingbu {
      width: 100%;
      background: #F9F9F9;

      .main_phone_shaixuan {
        height: 60px;
        width: 100%;
        background-color: #2f549f;
      }

      .main_phone_shaixuan_neirong {
        width: 100%;
        height: 365px;
        //padding-right: 15px;
        //padding-left: 15px;
        background-color: #2f549f;

        .main_phone_shaixuan_neirong_text {
          padding-left: 15%;
          height: 50px;
          font-size: 20px;
          line-height: 50px;
          color: #FFFFFF;
          border: 1px solid rgba(0, 0, 0, .2);

        }
      }

      .main_phone_sousuo_neirong {
        height: 70px;

        .main_phone_sousuo_kuang {
          float: left;
          margin-top: 10px;
          margin-left: 10%;
          width: 300px;
          height: 51px;
          border: 3px solid #2f549f;
        }
      }

      .main_fenlan {
        width: 80%;
        max-width: 1200px;
        height: 430px;
        //background: #FFFFFF;
        border-radius: 3px;
        margin-right: auto;
        margin-left: auto;

        .main_fenlan_neirong {
          float: left;
          width: 220px;
          height: 430px;
          background: #FFFFFF;
          opacity: 0.95;

          .main_fenlan_neirong_list {
            width: 100%;
            height: 62px;

            .main_fenlan_neirong_list_img {
              width: 20px;
              height: 20px;
              margin-top: 21px;
              margin-left: 17px;
              float: left;
            }

            .main_fenlan_neirong_list_text {
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #333333;
              float: left;
              margin-top: 18px;
              margin-left: 13px;
              //line-height: 100px;
            }
          }
        }

        .main_lunbo {
          float: left;
          //margin-left: 15px;
          margin-top: 15px;
          width: 720px;
          height: 415px;
        }

        .main_fenglu {
          float: left;
          width: 230px;
          height: 414px;
          background: #FFFFFF;
          border-radius: 5px;
          margin-top: 15px;
          //margin-left: 15px;

          .main_fenglu_fenge {
            width: 183px;
            height: 1px;
            background: #F1F1F1;
            border-radius: 1px;
            position: absolute;
            margin-top: 114px;
            margin-left: 24px;
          }

          .main_fenglu_huanyi {
            //width: 84px;
            //height: 22px;
            font-size: 22px;
            float: left;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            margin-left: 24px;
            margin-top: 24px;
            //line-height: 100px;
          }

          .main_fenglu_huanyi2 {
            //width: 56px;
            //height: 14px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            float: left;
            position: absolute;
            margin-top: 33px;
            margin-left: 114px;
            //line-height: 100px;
          }

          .main_fenglu_button {
            width: 80px;
            color: #4E6EF2;
            height: 24px;
            background: #FFFFFF;
            border: 1px solid #4E6EF2;
            border-radius: 4px;
            position: absolute;
            margin-left: -80px;
            margin-top: 70px;
          }

          .main_fenglu_button2 {
            color: #FFFFFF;
            width: 80px;
            height: 24px;
            border: none;
            background: linear-gradient(-30deg, #6789F4 0%, #4E6EF2 100%);
            border-radius: 4px;
            position: absolute;
            margin-left: 16px;
            margin-top: 70px;
          }

          .main_fenglu_rukou {
            width: 76px;
            height: 76px;
            //background: #888888;
            float: left;

            .main_fenglu_rukou_beijing {
              width: 36px;
              height: 36px;
              background: linear-gradient(0deg, #4E6EF2 0%, #7E9BF5 100%);
              border-radius: 50%;
              margin-left: 19px;
              margin-top: 12px;

              .main_fenglu_rukou_beijing_img {
                margin-left: 7px;
                margin-top: 8px;
              }
            }

            .main_fenglu_rukou_text {
              margin-top: 4px;
              margin-left: 17px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #666666;
              //line-height: 100px;
            }
          }

          .main_fenglu_fubiao {
            width: 192px;
            margin-left: 20px;
            margin-top: 140px;
            //height: 40px;
          }

          .main_fenglu_fubiao2 {
            width: 192px;
            margin-left: 20px;
            margin-top: 200px;
          }

          .el-divider {
            background-color: #333333;
          }

          .el-divider--horizontal {
            height: 1px;
          }

          .el-divider__text {
            padding: 0 5px;
          }

          .main_fenglu_pingtai {
            float: left;
            //width: 57px;
            //height: 14px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            margin-left: 15px;
            //line-height: 100px;
          }
        }
      }

      .main_pinpai_jiange {
        width: 100%;
        height: 85px;

      }

      .main_pinpai {
        width: 80%;
        max-width: 1200px;
        //height: 300px;
        background: #FFFFFF;
        border-radius: 3px;
        margin-right: auto;
        margin-left: auto;

        .main_pinpai_jiange_biaoti {
          font-size: 30px;
          margin-top: -52px;
          position: absolute;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          //line-height: 100px;
        }

        .main_pinpai_logo_fenge {
          width: 1100px;
          height: 1px;
          background: #F1F1F1;
          position: absolute;
          margin-top: 150px;
          margin-left: 50px;
        }

        .main_pinpai_logo_neirong {
          //height: 100px;
          width: 100%;
          float: left;

          .main_pinpai_logo_neirong_img {
            width: 100%;
            height: 100%;
            //margin-top: 35px;
            //margin-left: 68px;
          }
        }

        .main_pinpai_logo_fenge_right {
          width: 1px;
          height: 100px;
          background: #F1F1F1;
          float: left;
          margin-top: 25px;
        }
      }

      .main_shangpin {
        width: 80%;
        max-width: 1200px;
        height: 750px;
        //background: #FFFFFF;
        border-radius: 3px;
        margin-right: auto;
        margin-left: auto;

        .main_shangpin_lanmu {
          width: 100%;
          height: 80px;
          background: #FFFFFF;
          text-align: center;
          border-radius: 2px;
          line-height: 130px;

          .main_shangpin_lanmu {
            display: table-cell;
            vertical-align: middle;

            .main_shangpin_lanmu_img {
              display: inline-block;
            }
          }

          .main_shangpin_hentiao_left {
            position: absolute;
            margin-top: 33px;
            margin-left: 398px;
            float: left;
            width: 116px;
            height: 6px;
            background: linear-gradient(90deg, rgba(209, 195, 252, 0) 0%, #814CE4 100%);
          }

          .main_shangpin_hentiao_left2 {
            width: 64px;
            height: 4px;
            position: absolute;
            float: left;
            margin-top: 40px;
            margin-left: 450px;
            background: linear-gradient(90deg, rgba(209, 195, 252, 0) 0%, #814CE4 100%);
          }

          .main_shangpin_hentiao_right {
            position: absolute;
            margin-top: -40px;
            margin-left: 680px;
            width: 116px;
            height: 6px;
            background: linear-gradient(-90deg, rgba(209, 195, 252, 0) 0%, #814BE4 100%);
          }

          .main_shangpin_hentiao_right2 {
            width: 64px;
            height: 4px;
            position: absolute;
            margin-top: -32px;
            margin-left: 681px;
            background: linear-gradient(-90deg, rgba(209, 195, 252, 0) 0%, #814BE4 100%);
          }

          .main_shangpin_lanmu_text {
            text-align: center;
            //width: 124px;
            //height: 29px;
            //  float: contour;
            //  top: 20px;
            padding-top: 14px;
            //  margin-top: 20px;
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #834CE4;
            //line-height: 100px;
          }

          .main_shangpin_lanmu_text2 {
            text-align: center;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #666666;
            //line-height: 100px;
          }
        }

        .main_shangpin_neirong {
          width: 100%;
          height: 320px;
          background: #FFFFFF;
          border-radius: 3px;
          float: left;
          margin-top: 20px;
          margin-right: 15px;
          text-align: left;
          position: relative;

          .main_shangpin_neirong_img {
            width: 100%;
            height: 215px;
            //background: #aa7700;
          }

          .main_shangpin_neirong_biaoqian {
            //margin-left: auto;
            //margin-right: auto;
            text-align: center;
            width: 60px;
            position: absolute;
            height: 24px;
            border: 1px solid #8450E4;
            border-radius: 2px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #854FE5;
            float: right;
            margin-top: -210px;
            right: 5px;
            //margin-left: 100px;
            line-height: 24px;
          }

          .main_shangpin_neirong_biaoti {

            //width: 176px;
            //height: 34px;
            font-size: 14px;
            /*margin-left: 20px;*/
            text-align: center;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 20px;
            width: 90%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top: 10px;

          }

          /*.main_shangpin_neirong_biaoti:hover{*/
          /*  text-overflow: ellipsis;*/
          /*  white-space: nowrap;*/
          /*}*/

          .main_shangpin_neirong_haopin {
            float: left;
            width: 60px;
            height: 12px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 100;
            color: #999999;
            line-height: 20px;
            margin-left: 20px;
            margin-top: 11px;
          }

          .main_shangpin_neirong_jiage {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #F03726;
            line-height: 20px;
            text-align: center;
            margin-top: 20px;
          }
        }
      }

      .main_fuwuzhida {
        width: 80%;
        max-width: 1200px;
        height: 370px;
        //background: #FFFFFF;
        border-radius: 3px;
        margin-right: auto;
        margin-left: auto;

        .main_fuwuzhida_fenmian {
          float: left;
          background: #FFFFFF;
          background-image: url("../../../assets/home/fuwuzhida.png");
          width: 471px;
          height: 240px;

          .main_fuwuzhida_fenmian_img {
            width: 235px;
          }

          .main_fuwuzhida_fenmian_text {
            float: left;
            width: 157px;
            height: 36px;
            font-size: 38px;
            font-family: SweiAxSansCJKtc;
            font-weight: 500;
            color: #6783F9;
            line-height: 30px;
            margin-top: 81px;
            margin-left: 266px;
          }

          .main_fuwuzhida_fenmian_text2 {
            float: left;
            width: 120px;
            height: 19px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            margin-left: 267px;
            margin-top: 19px;
          }
        }

        .main_fuwuzhida_neirong {
          width: 100%;
          height: 110px;
          //margin-left: 15px;
          margin-bottom: 20px;
          background: #FFFFFF;
          float: left;
        }
      }

      .main_tesefuwuzhida_jiange {
        width: 100%;
        height: 51px;
      }

      .main_tesejiance {
        width: 80%;
        max-width: 1200px;
        height: 399px;
        background: #FFFFFF;
        border-radius: 3px;
        margin-right: auto;
        margin-left: auto;

        .main_jiance_fenmian {
          //background-image: url("../../../assets/home/jiance_fengmian.png");
          width: 100%;
          height: 399px;
          //background: #6783F9;
          //opacity: 0.3;
          border-radius: 3px;
          float: left;
        }

        .main_jiance_fenmian_juxing {
          //width: 195px;
          width: 18%;
          max-width: 195px;
          height: 92px;
          background: #000000;
          opacity: 0.6;
          border-radius: 20px 3px 40px 3px;
          position: absolute;
          margin-top: 46px;
          margin-left: 20px;

          .main_jiance_fenmian_juxing_text {
            width: 106px;
            height: 25px;
            font-size: 26px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 30px;
            margin-top: 22px;
            margin-left: 28px;
          }

          .main_jiance_fenmian_juxing_text2 {
            //width: 66px;
            height: 15px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 30px;
            margin-left: 28px;
            margin-top: 3px;
          }
        }

        .main_jiance_jiange {
          position: absolute;
          margin: 199px 47px 0 283px;
          float: left;
          width: 870px;
          height: 1px;
          background: #E1E1E1;
        }

        .main_jiance_sj {
          position: relative;
          // width: 100%;
          height: 399px;
          // float: left;
          //border-right: #E1E1E1 solid 1px;
          .main_jiance_sj_neirong {
            //border-right: #E1E1E1 solid 1px;
            float: left;
            //margin: 41px 0 41px 0;

            align-content: center;
            //width: 193px;
            //height: 117px;
            //background: #aa7700;
            .main_jiance_sj_neirong_img {
              width: 100%;
              height: 100%;
            }
            .neirong-title{

              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .main_jinpaijiance_jiange {
        width: 100%;
        height: 70px;
      }

      .main_width {
        width: 80%;
        max-width: 1200px;
        margin-right: auto;
        margin-left: auto;

        .main_jinpai_top {
          width: 100%;
          height: 94px;
          background-color: #FFFFFF;
          margin-bottom: 7px;

          .main_jinpai_top_img {
            margin-top: -10px;
          }

          .main_jinpai_top_img2 {
            margin-top: 26px;
            margin-left: -450px;
            width: 33px;
            height: 40px;
            position: absolute;
          }

          .main_jinpai_top_text {
            //width: 216px;
            //height: 40px;
            font-size: 40px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            //line-height: 30px;
            margin-top: -95px;
            margin-left: 85px;
          }

          .main_jinpai_top_text2 {
            //width: 74px;
            //height: 19px;
            float: right;
            margin-top: -40px;
            margin-right: 40px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
          }
        }

        .main_jinpai {
          .main_gcs_liebiao {
            width: 380px;
            float: left;
            height: 200px;
            background: #FFFFFF;
            //margin-right: 20px;
            border-radius: 10px;
            margin-top: 150px;

            .main_gcs_liebiao_top {
              width: 100%;
              height: 55px;


              .main_gcs_liebiao_top_img {
                width: 135px;
                height: 135px;
                //border-radius: 50%;
                margin-top: -110px;
                margin-left: 120px;
                position: absolute;
              }
            }

            .jinpai_name {
              margin-top: 55px;
              /*margin-left: 95px;*/
            }

            .jinpai_zhicheng {
              margin-top: 55px;
              margin-left: 10px;
              /*margin-left: 15px;*/
            }

            .jinpai_jingli {
              /*margin: 30px 24px 0 29px;*/
              margin-left: 30px;
              margin-top: 24px;
              color: #8c8c8c;
              font-size: 16px;
            }
          }

        }

      }

      .main_jinpai_bottom {
        position: relative;
        width: 100%;
        height: 231px;
      }

      .main_phone_shaixuan {

      }
    }

    /*  .footer {*/
    /*    width: 100%;*/
    /*    height: 255px;*/
    /*    background: #FFFFFF;*/
    /*    border-bottom: #E1E1E1 solid 1px;*/

    /*    .footer_width {*/
    /*      text-align: center;*/
    /*      width: 80%;*/
    /*      max-width: 1200px;*/
    /*      margin-right: auto;*/
    /*      margin-left: auto;*/

    /*      .xdsk_top {*/
    /*        position: relative;*/
    /*        margin-top: 70px;*/

    /*        .footer_img_xinshou {*/
    /*          //margin-left: 5px;*/
    /*          //margin-top: 13px;*/
    /*          position: absolute;*/
    /*          width: 50px;*/
    /*          height: 50px;*/
    /*        }*/

    /*        .footer_img_duiwai {*/
    /*          //margin-left: 155px;*/
    /*          //margin-top: 13px;*/
    /*          //margin-top: 13px;*/
    /*          position: absolute;*/
    /*          width: 50px;*/
    /*          height: 50px;*/
    /*        }*/

    /*        .footer_img_shiming {*/
    /*          //margin-left: 155px;*/
    /*          //margin-top: 13px;*/
    /*          position: absolute;*/
    /*          width: 50px;*/
    /*          height: 50px;*/
    /*        }*/

    /*        .footer_img_kefu {*/
    /*          //margin-left: 155px;*/
    /*          //margin-top: 13px;*/
    /*          position: absolute;*/
    /*          width: 50px;*/
    /*          height: 50px;*/
    /*        }*/

    /*        .footer_xinshou_left {*/
    /*          margin-left: 60px;*/
    /*        }*/

    /*        .footer_dsk_left {*/
    /*          margin-left: 60px;*/
    /*        }*/
    /*      }*/

    /*      .xdsk_bottom {*/
    /*        margin-top: 38px;*/

    /*        .footer_kongjian_left {*/
    /*          margin-left: 17px;*/
    /*        }*/

    /*        .footer_jiaoyi_left {*/
    /*          margin-left: 184px;*/
    /*        }*/

    /*        .footer_shiming_left {*/
    /*        }*/

    /*        .footer_tousu_left {*/
    /*          margin-left: 520px;*/
    /*        }*/

    /*        .footer_changjian_left {*/
    /*          margin-left: 945px;*/
    /*        }*/
    /*      }*/

    /*      .glzy_top {*/
    /*        margin-top: 51px;*/

    /*        .footer_gyyyj_left {*/
    /*          padding-right: 20px;*/
    /*          border-right: #E1E1E1 solid 1px;*/
    /*        }*/

    /*        .footer_lxwm_left {*/
    /*          margin-left: 29px;*/
    /*          padding-right: 21px;*/
    /*          border-right: #E1E1E1 solid 1px;*/
    /*        }*/
    /*      }*/

    /*      .glzy_bottom {*/
    /*        margin-top: 45px;*/
    /*      }*/
    /*    }*/
    /*  }*/

    /*  .footer_bottom {*/
    /*    border-bottom: none;*/
    /*    height: 223px;*/
    /*  }*/
    /*}*/

    /*.youfudong {*/
    /*  float: right;*/
    /*}*/
    /*.footer_text1 {*/
    /*  font-size: 16px;*/
    /*  font-family: Source Han Sans CN;*/
    /*  font-weight: 150px;*/
    /*  color: #666666;*/
    /*  //line-height: 30px;*/
    /*}*/

    /*.footer_text2 {*/
    /*  font-size: 16px;*/
    /*  font-family: Source Han Sans CN;*/
    /*  font-weight: 400;*/
    /*  color: #666666;*/
    /*  //line-height: 30px;*/
    /*}*/

    /*.footer_text3 {*/
    /*  font-size: 30px;*/
    /*  font-family: Source Han Sans CN;*/
    /*  font-weight: 550px;*/
    /*  color: #333333;*/
    /*  //line-height: 30px;*/
    /*}*/

    .main_jinpai_text {
      //width: 78px;
      //height: 25px;
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #222222;
      line-height: 30px;
    }

    .main_jinpai_text2 {
      //width: 327px;
      //height: 50px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 350px;
      color: #333333;
      line-height: 30px;
    }

    .xuanzhong:hover {
      //color:#4E6EF2;
      text-decoration: none;
    }

    .wenzi {
      text-decoration: none;
    }

    .lanmu:hover {
      background-color: #FF704D !important;
    }
  }
</style>